'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'baby';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f77c';
var svgPathData = 'M359.7 216.2l42.8-30c14.5-10.1 18-30.1 7.799-44.6c-10.1-14.5-30.1-18-44.6-7.801l-42.8 30C264 205.1 184 205.1 125.1 163.8l-42.8-30c-14.5-10.2-34.5-6.6-44.6 7.801C27.5 156.1 31 176 45.5 186.2l42.8 30c17.4 12.2 36.2 21.4 55.6 28.5v86.26L95.1 396c-9.102 11.4-9.301 27.5-.6016 39.2l48 64C148.8 507.6 158.4 512 168.1 512c6.701 0 13.4-2.1 19.2-6.4c14.2-10.6 17-30.7 6.4-44.8l-33.1-44.2l18.3-22.9c11.3 9 25.2 14.2 39.8 14.2h10.1c14.6 0 28.5-5.201 39.8-14.2l18.3 22.9l-33.1 44.2c-10.6 14.1-7.799 34.2 6.4 44.8C266.9 509.9 273.6 512 280.3 512c9.799 0 19.3-4.4 25.6-12.8l48-64c8.799-11.7 8.5-27.8-.6016-39.2l-48.1-65.25V244.7C323.6 237.6 342.3 228.4 359.7 216.2zM272.1 333l-29.06 29.08C239.2 365.9 234.2 368 228.9 368H219.3c-5.359 0-10.36-2.078-14.11-5.875l-29.08-29.08V312h96V333zM224 159.1c44.2 0 79.99-35.8 79.99-79.1C303.1 35.8 268.2 0 224 0C179.8 0 144 35.8 144 79.1C144 124.2 179.8 159.1 224 159.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBaby = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;